module.exports = __webpack_public_path__ + "static/media/604JamesPBrawleyDrSW_2018-06-12_182.d676af79.jpg";